import type { Session, SessionUploadedBy } from 'api';
import { formatDate } from 'date';
import { useTranslation } from 'i18n';
import { Box, Stack, Typography } from 'ui';

import { AIChip } from '../../index';
import { formatEvidenceSessionOrigin } from '../../utils/formatEvidenceSessionOrigin';
import { SelfServeChip } from '../SelfServeChip/SelfServeChip';

export const EvidenceSessionSummary = ({
  date,
  origin,
  uploadedBy,
  showAIChip = false,
  showSelfServeChip = false,
}: {
  date: string;
  origin: Session['origin'];
  uploadedBy: SessionUploadedBy;
  showAIChip?: boolean;
  showSelfServeChip?: boolean;
}) => {
  const { t } = useTranslation('features');
  const uploadedByName = uploadedBy?.full_name || t('backlog.evidence.sessionSummary.anonymous');

  return (
    <Stack direction="column">
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          alignItems: 'center',
        }}
      >
        <Typography fontWeight="bold">{formatDate(date)}</Typography>
        {showAIChip ? <AIChip /> : null}
        {showSelfServeChip ? <SelfServeChip /> : null}
      </Box>
      <Typography variant="body2">
        {origin
          ? t('backlog.evidence.sessionSummary.withOrigin', {
              values: {
                origin: formatEvidenceSessionOrigin(origin),
                uploadedBy: uploadedByName,
              },
            })
          : t('backlog.evidence.sessionSummary.withoutOrigin', {
              values: {
                uploadedBy: uploadedByName,
              },
            })}
      </Typography>
    </Stack>
  );
};
